import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "data-item user" };
const _hoisted_2 = { class: "data-item__header" };
const _hoisted_3 = { class: "data-item__title" };
const _hoisted_4 = { class: "data-item__actions" };
const _hoisted_5 = { class: "data-item__content" };
const _hoisted_6 = {
    key: 0,
    class: "data-item__section"
};
import { onMounted, ref } from 'vue';
import { useRouter } from "vue-router";
import customerRepository from '@astina/paloma-shop-common-ui/src/services/CustomerRepository';
import events from "@astina/paloma-common-ui/src/services/EventBus";
import AppForm from "@astina/paloma-common-ui/src/components/form/AppForm.vue";
import { saveUser } from "../commands/SaveUser";
import ValidationUtils from "@astina/paloma-common-ui/src/services/ValidationUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserCreateView',
    setup(__props) {
        const router = useRouter();
        const draft = ref({
            emailAddress: '',
            enabled: true,
            roles: [],
            sendInvitation: true,
        });
        const form = ref(null);
        const validation = ref(ValidationUtils.emptyValidation());
        onMounted(() => {
            customerRepository.getUserForm().then(formParam => {
                form.value = formParam;
            });
        });
        function save() {
            saveUser(draft.value)
                .then(user => {
                router.push({ name: 'config_users_user', params: { id: user.id } });
                events.$emit('users.activate', user.id);
            })
                .catch(validationParam => {
                validation.value = validationParam;
            });
        }
        function cancel() {
            router.push({ name: 'config_users' });
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    _createElementVNode("template", null, [
                        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('user.create')), 1),
                        _cache[0] || (_cache[0] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_router_link, {
                                to: { name: 'config_users' },
                                class: "button button--outline"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                                ]),
                                _: 1
                            })
                        ])
                    ])
                ]),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createElementVNode("div", _hoisted_5, [
                    (form.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(AppForm, {
                                form: form.value,
                                data: draft.value,
                                validation: validation.value,
                                onSubmit: save,
                                onCancel: cancel,
                                "submit-icon": "save",
                                "submit-label": _ctx.$t('save')
                            }, null, 8, ["form", "data", "validation", "submit-label"])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
